























































































import { Component, Watch } from "vue-property-decorator";

import MagicValidator from "../../../magic/MagicValidator.vue";
import WidgetBase from "../WidgetBase";

import {
  qiyuesuoCreateByCategory,
  qiyuesuoAddSignatory,
  qiyuesuoContractCancel,
  qiyuesuoContractViewPageUrl
} from "../../../api/index";

import { uid, current } from "@szgc/plt-core-v2";
import ContractLockHtml from "../../../ContractLock/ContractLock.html";

@Component({
  name: "ContractLockWidget",
  components: { MagicValidator }
})
export default class ContractLockWidget extends WidgetBase {
  public visible: boolean = false;

  public signed: boolean = false;

  public loading!: any;

  private openedWindow!: Window | null;

  showH5Sign(signUrl: string) {
    this.visible = true;
    const ContractLockHtmlRowUrl = URL.createObjectURL(
      new Blob([ContractLockHtml], { type: "text/html" })
    );
    const url = `${ContractLockHtmlRowUrl}`;
    this.openedWindow = window.open(url);
    if (!this.openedWindow) return;
    this.openedWindow.onload = () => {
      this.openedWindow &&
        this.openedWindow.postMessage(
          {
            action: "SIGN_OPENED",
            data: {
              contractId: this.ext.attId,
              contractName: this.ext.fileName,
              signUrl: signUrl
            }
          },
          "*"
        );
    };
  }

  async closeH5Sign() {
    if (!this.signed) {
      this.visible = false;
    } else {
      let confirm;
      try {
        confirm = await this.$confirm("有新签章尚未保存，确定要关闭？", "提示", {
          type: "warning"
        });
      } catch (error) {
        confirm = false;
      }
      if (!confirm) return;
      this.visible = false;
    }
  }

  onSignOpened() {
    // TODO
  }
  @Watch("widget.ext", { deep: true,immediate:true })
  onExtChange() {
    this.ext = JSON.parse(JSON.stringify(this.widget.ext || {}));
  }
  mounted() {
    window.addEventListener("message", this.onReciveMessage, false);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("message", this.onReciveMessage, false);
    });
  }

  onReciveMessage(e: MessageEvent) {
    try {
      if (e.source !== this.openedWindow) return;
      const data = JSON.parse(e.data);
      if (data.action !== "SIGN_COMPLETE_SIGN") return;
      this.$message.success(data.label);
      this.openedWindow && this.openedWindow.close();
      this.signed = true;
    } catch (error) {
      console.error(error);
      this.$message.error("无效的消息");
      this.signed = false;
    }
  }

  public ext: { attId: string; fileName: string; requestRelativeUri: string } = {
    attId: "",
    fileName: "",
    requestRelativeUri: ""
  };

  async view() {
    const res = await this.qiyuesuoContractViewPageUrl();
    if (res) {
      window.open(res);
    }
  }

  async deleteFile() {
    let confirm;
    try {
      confirm = await this.$confirm("删除后文件将永久作废，确定删除文件？", "提示", {
        type: "warning"
      });
    } catch (error) {
      confirm = false;
    }
    if (!confirm) return;
    const res = await this.qiyuesuoContractCancel();
    if (res) {
      this.$set(this.widget, "value", "");
      this.signed = false;
      // this.$nextTick(() => {
      //   // this.widget.value = "";
      //   // this.value = "";
      //   this.hiddenHack = false;
      // });
    }
  }

  download() {
    const a = document.createElement("a");
    // console.log(this.ext);
    a.href = this.ext.requestRelativeUri;
    a.download = this.ext.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async onFileChange(data: { raw: File }) {
    const formData = new FormData();
    formData.append("file", data.raw);
    formData.append("reqToken", uid());
    formData.append("propertyNamePath", this.widget.path);
    formData.append("title", data.raw.name);
    formData.append("fileType", "pdf");
    formData.append("subject", this.widget.name as string);
    try {
      const { success, data, message } = await qiyuesuoCreateByCategory(
        this.widget.pac.businessId,
        formData
      );

      if (!success) {
        this.$message.error(message);
        return;
      }
      this.$nextTick(() => {
        this.$set(this.widget, "value", `${data.uploadVo.fileId}-${data.constractId}`);
        this.$set(this, "value", `${data.uploadVo.fileId}-${data.constractId}`);

        this.ext.attId = data.uploadVo.fileId;
        this.ext.fileName = data.uploadVo.name;
        this.ext.requestRelativeUri = data.uploadVo.requestUri;
      });
    } catch (error) {
      console.error(error);
      this.$message.error("文件上传失败");
    }
  }
  async qiyuesuoAddSignatory() {
    try {
      const { success, data, message } = await qiyuesuoAddSignatory({
        constractId: this.value?.split("-")[1] || "",
        signatoryUserName: current.username
      });
      if (!success) {
        this.$message.error(message);
        return false;
      }

      if (data) {
        this.showH5Sign(data);
      }
    } catch (error) {
      console.error(error);
      this.$message.error("获取签章地址失败");
      return false;
    }
  }
  async qiyuesuoContractCancel() {
    try {
      const { success, message } = await qiyuesuoContractCancel(this.value?.split("-")[1] || "");
      if (!success) {
        this.$message.error(message);
        return false;
      }
      return true;
    } catch (error) {
      console.error(error);
      this.$message.error("删除电子签约失败");
      return false;
    }
  }
  async qiyuesuoContractViewPageUrl() {
    try {
      const { success, data, message } = await qiyuesuoContractViewPageUrl(
        this.value?.split("-")[1] || ""
      );
      if (!success) {
        this.$message.error(message);
        return false;
      }
      return data;
    } catch (error) {
      console.error(error);
      this.$message.error("获取电子查看签约页面地址失败");
      return false;
    }
  }
  onUploadSuccess(res: any) {
    console.log(res);
  }
}
